<template>
  <div>
    <b-modal ref="tecAnalysisModal"
             id="tecAnalysisModal"
             size="xl"
             :no-close-on-esc="true"
             :hide-footer="true"
             scrollable
             @hide="onClose">
      <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span v-if="tecAnalysisType === tecAnalysisTypes.AT" class="modalTitle ml-auto">
            {{$lang.PCI.AT.Title}}
          </span>
          <span v-else class="modalTitle ml-auto">
            {{$lang.PCI.AT.TitleQuote}}
          </span>
          <button class="close" @click="$refs.tecAnalysisModal.hide()">x</button>
        </div>
      </template>
      <div class="d-flex flex-wrap">
        <b-alert class="w-100" variant="danger" :dismissible="false" v-model="block.block"><strong>{{ `Somente LEITURA, sendo editado por: ${block.name}` }}</strong></b-alert>
        <div class="d-flex align-items-center col-12 mb-3">
          <div class="flex-grow-1 mr-3">
            <strong class="mr-1">{{$lang.PCI.AT.LabelContractReference}}:</strong>
            <b-input v-model="pci.referenciaContrato" :readonly="true" tabindex="-1" class="w-100"></b-input>
          </div>
          <div v-if="tecAnalysisType === tecAnalysisTypes.AT" style="flex-grow: 5;">
            <strong class="mr-1">Sites:</strong>
            <v-select v-model="works" :getOptionLabel="param => `${param.idSite} (${param.referencia})`" multiple :disabled="!statusEditable" style="width: 100%;" @option:deselected="onRemoveWork"></v-select>
          </div>
        </div>
        <div class="d-flex align-items-center col-12 mb-3">
          <strong class="mr-1">LPU:</strong>
          <v-select v-model="lpuPciID" label="text" :reduce="param => param.value" :options="objListLpu" :disabled="isReadOnly" class="w-100"></v-select>
        </div>
        <div class="d-flex flex-wrap col align-itens-center">
          <b-checkbox switch v-model="showRevisions" @change="processList" class="d-flex"></b-checkbox> {{ $lang.PCI.AT.LabelShowRevisions }}
          <div v-if="!isReadOnly" class="d-flex flex-grow-1">
            <div class="d-flex justify-content-end col-12 mb-1 px-0">
              <b-button rounded
                        no-caret
                        variant="link"
                        class="p-0 mx-1"
                        tabindex="-1"
                        @click="$emit('SelectFolder', pci.obraId)"
                        v-if="works.length === 1"
                        v-b-tooltip.hover :title="$lang.PCI.AT.TooltipAddFolder">
                <i class="fas fa-folder-plus text-third"></i>
              </b-button>
              <b-button rounded
                        no-caret
                        variant="link"
                        class="p-0 mx-1"
                        tabindex="-1"
                        @click="$emit('OpenFolder', {obraId: pci.obraId, gedPastaId: pci.gedPastaId})"
                        v-if="works.length === 1 && pci.gedPastaId"
                        v-b-tooltip.hover :title="$lang.PCI.AT.TooltipOpenFolder">
                <i class="far fa-folder text-third"></i>
              </b-button>
              <b-button rounded
                        no-caret
                        variant="link"
                        class="p-0 mx-1"
                        v-if="tecAnalysisType === tecAnalysisTypes.AT"
                        @click="onShowQuotesToImport"
                        tabindex="-1"
                        v-b-tooltip.hover :title="$lang.PCI.AT.TooltipImportQuote">
                <i class="fas fa-download text-primary"></i>
              </b-button>
              <b-button rounded
                        no-caret
                        variant="link"
                        class="p-0 mx-1"
                        v-if="lpuPciID"
                        @click="onNewTecAnalysis"
                        tabindex="-1"
                        v-b-tooltip.hover :title="$lang.PCI.AT.TooltipNew">
                <i class="fas fa-plus-circle text-third"></i>
              </b-button>
              <b-button rounded
                        no-caret
                        variant="link"
                        class="p-0 mx-1"
                        v-if="canDesmembrar"
                        @click="onOpenDesmembrar"
                        tabindex="-1"
                        v-b-tooltip.hover :title="$lang.PCI.AT.TooltipDesmembrar">
                <i class="fas fa-code-branch text-primary"></i>
              </b-button>
              <b-button rounded
                        no-caret
                        variant="link"
                        class="p-0 mx-1"
                        v-if="statusCancelablePlanAndBudget"
                        @click="onCancelAT"
                        tabindex="-1"
                        v-b-tooltip.hover :title="$lang.PCI.AT.TooltipCancelAT">
                <i class="fas fa-ban text-danger"></i>
              </b-button>
              <b-button rounded
                        no-caret
                        variant="link"
                        class="p-0 mx-1"
                        v-if="statusEditablePlanAndBudget || (at && at.status && hasRole(roles.RW_OPER_PCI_AT_BUDGET))"
                        :disabled="!at"
                        @click="onDeleteAT"
                        tabindex="-1"
                        v-b-tooltip.hover :title="$lang.PCI.AT.TooltipDelete">
                <i class="fas fa-trash text-danger"></i>
              </b-button>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <ag-grid-vue class="ag-theme-alpine"
                      :getLocaleText="localeTextFunc"
                      :defaultColDef="defaultColumnDef"
                      :gridOptions="gridOptionsTecAnalysis"
                      :columnTypes="columnTypes"
                      :columnDefs="columnDefsTecAnalysis"
                      :rowData="objList"
                      :rowClassRules="atRowClassRules"
                      rowSelection="single"
                      :getRowId="params => params.data.id"
                      :suppressContextMenu="true"
                      :groupHeaderHeight="45"
                      :headerHeight="45"
                      :rowHeight="30"
                      :popupParent="gridPopupParent"
                      domLayout="autoHeight"
                      @selectionChanged="onRowSelect"
                      @firstDataRendered="onGridReady">
          </ag-grid-vue>
        </div>
        <div v-if="at && at.obsRejeicao" class="d-block align-items-start col-12 mb-3">
          <strong class="mt-2 mr-1">{{$lang.Common.LabelRejectReason}}:</strong>
          <b-textarea v-model="at.obsRejeicao" :readonly="true"></b-textarea>
        </div>
        <div v-if="at " class="d-flex flex-wrap align-items-center col-12">
          <div class="col-12 d-flex align-items-center mb-3">
            <strong v-if="tecAnalysisType === tecAnalysisTypes.Quote" class="mr-1">{{ 'ID Site' }}:</strong>
            <div v-if="tecAnalysisType === tecAnalysisTypes.Quote" class="mr-3">
              <b-input v-model="at.analiseTecCotacao.idSite" :disabled="!statusEditable" @change="onChangeAT" maxlength="50" style="width: 12em;" class="p-1"></b-input>
            </div>

            <strong class="mr-1">{{$lang.PCI.AT.LabelService}}:</strong>
            <div class="mr-3">
              <b-form-select type="text" ref="selectTypeAT" :options="serviceAnalysisTec" v-model="serviceAnalysisTecSelected" :disabled="!statusEditable" @change="onChangeAT" style="width: 200px;" />
            </div>

            <strong class="mr-1">{{$lang.PCI.AT.Sla}}:</strong>
            <div class="mr-3">
              <b-input type="number" v-model="at.sla" :disabled="!(at && at.status && (hasRole(roles.RW_OPER_PCI_AT_PLAN) || hasRole(roles.RW_OPER_PCI_AT_BUDGET) || statusEditable))" @change="onChangeAT" style="width: 50px;" class="p-1" />
            </div>

            <strong class="mr-1">{{ $lang.PCI.AT.LabelRegionUFFactor }}:</strong>
            <div class="mr-3 flex-grow-1">
              <b-input v-model="at.ufFatorRegiao" :disabled="!statusEditable" @change="onChangeAT" maxlength="50" class="p-1 w-100"></b-input>
            </div>

            <strong class="mr-1">{{ 'Operadora' }}:</strong>
            <div class="mr-3">
              <b-input v-model="at.operadora" :disabled="!statusEditable" @change="onChangeAT" maxlength="50" style="width: 15rem;" class="p-1"></b-input>
            </div>
          </div>
          <div class="col-12 d-flex align-items-center mb-3">
            <strong class="mr-1">
              {{$lang.PCI.AT.LabelTotalValue}}:
            </strong>
            <b-input
              type="text"
              v-model="tecAnalysisItemsSum"
              :readonly="true"
              class="text-right mr-3"
              style="width: 10rem;"></b-input>

            <strong v-if="hasRole(roles.RW_OPER_PCI_AT_BUDGET) || hasRole(roles.R_OPER_PCI_AT_READ)" class="mr-1">
              {{ $lang.PCI.AT.LabelMoneyFactor }}:
            </strong>
            <div v-if="hasRole(roles.RW_OPER_PCI_AT_BUDGET) || hasRole(roles.R_OPER_PCI_AT_READ)" class="mr-3">
              <b-input
                type="number"
                v-model="at.fatorMoeda"
                :disabled="!statusEditable"
                :readonly="isReadOnly"
                @change="onChangeAT"
                style="width: 50px;" />
            </div>

            <strong v-if="hasRole(roles.RW_OPER_PCI_AT_BUDGET) || hasRole(roles.R_OPER_PCI_AT_READ)" class="mr-1">
              {{ $lang.PCI.AT.LabelRegionFactor }}:
            </strong>
            <div v-if="hasRole(roles.RW_OPER_PCI_AT_BUDGET) || hasRole(roles.R_OPER_PCI_AT_READ)" class="mr-3">
              <b-input
                type="number"
                v-model="at.fatorRegiao"
                :disabled="!statusEditable"
                :readonly="isReadOnly"
                @change="onChangeAT"
                style="width: 50px;" />
            </div>

            <strong v-if="hasRole(roles.RW_OPER_PCI_AT_BUDGET) || hasRole(roles.R_OPER_PCI_AT_READ)" class="mr-1">
              {{ $lang.PCI.AT.LabelTaxesFactor }}:
            </strong>
            <div v-if="hasRole(roles.RW_OPER_PCI_AT_BUDGET) || hasRole(roles.R_OPER_PCI_AT_READ)" class="mr-3">
              <b-input
                type="number"
                v-model="at.fatorImposto"
                :disabled="!statusEditable"
                :readonly="isReadOnly"
                @change="onChangeAT"
                style="width: 50px;" />
            </div>

            <strong class="mr-1" style="text-wrap: nowrap;" v-if="statusEditable">{{ $lang.PCI.AT.LabelChangeLpu }}</strong>
            <div id="change-lpu" class="flex-grow-1 mr-3" v-if="statusEditable">
              <v-select v-model="lpuToChangeID" label="text" :reduce="param => param.value" class="w-100" :options="objListLpuToChange" @input="onChangeLpu"></v-select>
            </div>

            <b-button variant="third"
                      v-if="at.status && !isReadOnly && !statusEditable && !planRevising && !budgetRevising && hasRole(roles.RW_OPER_PCI_AT_REGIONAL)"
                      @click="onReview"
                      size="sm"
                      class="ml-3">
              <i class="fas fa-redo-alt mr-1"></i>{{$lang.PCI.AT.ButtonReviewRegional}}
            </b-button>
            <b-button variant="third"
                      v-if="at.status && planApprovable && hasRole(roles.RW_OPER_PCI_AT_PLAN)"
                      @click="onReviewPlan"
                      size="sm"
                      class="ml-3">
              <i class="fas fa-redo-alt mr-1"></i>{{$lang.PCI.AT.ButtonReviewPlanning}}
            </b-button>
            <b-button variant="third"
                      v-if="at.status && budgetApprovable && hasRole(roles.RW_OPER_PCI_AT_BUDGET)"
                      @click="onReviewBudget"
                      size="sm"
                      class="ml-3">
              <i class="fas fa-redo-alt mr-1"></i>{{$lang.PCI.AT.ButtonReviewBudget}}
            </b-button>
          </div>
          <div v-if="tecAnalysisType === tecAnalysisTypes.Quote" class="col-12 d-flex align-items-center mb-3">
            <strong v-if="tecAnalysisType === tecAnalysisTypes.Quote" class="mr-1">
              {{$lang.PCI.AT.LabelObservation}}:
            </strong>
            <b-input
              type="text"
              v-model="at.analiseTecCotacao.observacao"
              v-if="tecAnalysisType === tecAnalysisTypes.Quote"
              @change="onChangeAT"
              maxlength="200"
              class="mr-3 flex-grow-1"></b-input>
          </div>
          <div class="d-flex mb-1 mx-3"
            v-if="!viewLog && !viewLogRes && (hasRole(roles.RW_OPER_PCI_AT_PLAN) || hasRole(roles.RW_OPER_PCI_AT_BUDGET) || hasRole(roles.R_OPER_PCI_AT_READ))">
            <b-checkbox v-model="showAll" @change="processItems" switch>{{ $lang.PCI.AT.LabelShowAll }}</b-checkbox>
          </div>
          <div class="d-flex flex-grow-1 mx-3 justify-content-start">
            <i class="fas fa-th mx-2" @click="onShowAllColumns" v-show="!viewLog && !viewLogRes" b-v-tooltip.hover :title="$lang.PCI.Spreadsheet.ShowAllColumns"></i>
            <i class="fas fa-save mx-2" @click="onSaveLayout" v-show="!viewLog && !viewLogRes" b-v-tooltip.hover :title="$lang.PCI.Spreadsheet.SaveCurrentLayout"></i>
            <i class="fas fa-folder-open mx-2" @click="onLoadLayout" v-show="!viewLog && !viewLogRes" b-v-tooltip.hover :title="$lang.PCI.Spreadsheet.LoadSavedLayout"></i>
            <span class="mx-2" @click="onExportExcel" v-show="!viewLog && !viewLogRes">
              <i class="far fa-file-excel" v-b-tooltip.hover :title="this.$lang.PCI.Spreadsheet.ExcelExport"></i>
            </span>
            <span class="mx-2" @click="viewTecLog(true)" v-if="viewLog || viewLogRes">
              <i class="fas fa-angle-double-left" v-b-tooltip.hover :title="'Voltar'"></i>
            </span>
            <span class="mx-2" @click="viewTecLog(false)" v-if="at.status && viewLogRes">
              <i class="fas fa-history" v-b-tooltip.hover :title="'Log detalhado'"></i>
            </span>
            <span class="mx-2" @click="viewTecLog(false)" v-if="at.status && !viewLog && !viewLogRes">
              <i class="fas fa-history" v-b-tooltip.hover :title="'Log resumido'"></i>
            </span>
          </div>
        </div>
        <div v-show="!viewLog && !viewLogRes" class="col-12">
          <div v-show="at" class="col-12">
            <ag-grid-vue class="ag-theme-alpine"
                        ref="gridItems"
                        :getLocaleText="localeTextFunc"
                        :defaultColDef="defaultColumnDef"
                        :gridOptions="gridOptionsTecAnalysisItems"
                        :columnTypes="columnTypes"
                        :columnDefs="columnDefs"
                        :rowData="tecAnalysisItems"
                        :rowClassRules="itemRowClassRules"
                        :getRowStyle="getRowItemStyle"
                        :getRowId="params => params.data.id"
                        :suppressContextMenu="true"
                        :stopEditingWhenCellsLoseFocus="true"
                        :groupHeaderHeight="45"
                        :headerHeight="45"
                        :rowHeight="30"
                        @cell-editing-started="editing = true"
                        @cell-editing-stopped="editing = false"
                        @cell-value-changed="onChange"
                        @first-data-rendered="onGridReadyItems"
                        style="width:100%; height: calc(100vh - 160px);"
                        >
            </ag-grid-vue>
          </div>
          <b-card :header="$lang.PCI.AT.AdditiveTitle"
                  v-if="at && (additive || (extraItems && extraItems.length))"
                  class="d-flex flex-wrap mt-3 w-100 mx-3">
            <div class="d-flex col-12 px-0" v-if="!additive && extraItems && extraItems.length">
              <Tables ref="tableGrid"
                      :value="extraItems"
                      :columns="additiveColumns"
                      :showHeader="false"
                      :showPaging="false"
                      class="col-12">
                <tr v-for="(obj, index) in extraItems" :key="index">
                  <TableColumn :IsText="true" v-on:Edit="onEditAdditive(obj)" :value="obj.sequencia" />
                  <TableColumn :IsText="true" v-on:Edit="onEditAdditive(obj)" :value="obj.descricao" />
                  <TableColumn :IsText="true" v-on:Edit="onEditAdditive(obj)" :value="obj.analiseTecItemDetalhe.unidade" />
                  <TableColumn :IsText="true" v-on:Edit="onEditAdditive(obj)" :value="obj.analiseTecItemDetalhe.quantidade.toLocaleString('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2})" classCss="text-right" />
                  <TableColumn :IsText="true" v-on:Edit="onEditAdditive(obj)" :value="obj.analiseTecItemDetalhe.valor.toLocaleString('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2})" classCss="text-right" />
                  <TableColumn :IsText="true"
                              v-on:Edit="onEditAdditive(obj)"
                              :value="(obj.analiseTecItemDetalhe.quantidade * obj.analiseTecItemDetalhe.valor).toLocaleString('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2})"
                              classCss="text-right" />
                  <TableColumn :IsActionsButtons="true" v-if="budgetApprovable && hasRole(roles.RW_OPER_PCI_AT_BUDGET)" classCss="d-flex justify-content-center" :HasChange="false" v-on:Delete="onDeleteAdditive(obj)" />
                  <TableColumn :IsCustom="true" v-else></TableColumn>
                </tr>
              </Tables>
            </div>

            <additive v-model="additive"
                      v-if="additive && budgetApprovable && hasRole(roles.RW_OPER_PCI_AT_BUDGET)"
                      @Clear="additive = null"
                      @Create="onCreateAdditive"
                      @Update="onUpdateAdditive"
                      :list="extraItems"
                      :columnDefs="columnDefs"
                      class="mt-1" />
          </b-card>
          <div v-if="at" class="d-flex flex-wrap align-items-center col mt-3">
            <strong class="mr-1">{{$lang.PCI.AT.LabelTotalValue}}:</strong>
            <b-input type="text" v-model="tecAnalysisItemsCalculatedSum" :readonly="true" class="text-right" style="width: 200px;"></b-input>
          </div>
          <div v-if="at" class="d-flex flex-wrap col-12 mt-3">
            <strong>{{$lang.PCI.AT.LabelLpuObservation}}:</strong>
            <b-textarea rows="3" max-rows="10" v-model="at.lpu.observacao" maxlength="4000" :readonly="true"></b-textarea>
            <strong>{{$lang.PCI.AT.LabelObservation}}: <span v-if="editingObs === -1">{{ $lang.Common.Editing }} <i class="fas fa-angle-double-left m-2" @click="editingObs = null"></i> </span></strong>

            <div class="d-flex align-items-center mb-1 w-100" v-if="editingObs === null">
              <b-textarea max-rows="10" v-model="concatObservation" maxlength="4000" :readonly="true"></b-textarea>
              <i class="fas fa-pen m-2" v-if="hasRole(roles.RW_OPER_PCI_ADM)" @click="editingObs = -1"></i>
            </div>

            <div v-for="(observacao, idx) in at.observacoes" :key="idx" class="w-100">
              <div class="d-flex align-items-center mb-1 w-100" v-if="editingObs === -1">
                <b-input :id="'txtObs' + idx" type="text" class="ml-2" v-model="observacao.observacao.split('\n').filter(o => o.trim() !== '')[0]" readonly style="text-overflow: ellipsis;"></b-input>
                <b-popover :target="'txtObs' + idx"
                            triggers="hover"
                            ref="popover"
                            placement="top"
                            boundary="window"
                            @show="onShowObsPopover($event, observacao)">
                  <pre>{{observacao.observacao}}</pre>
                </b-popover>
                <i class="fas fa-pen m-2" v-if="hasRole(roles.RW_OPER_PCI_ADM)" @click="editingObs = idx"></i>
              </div>
              <div class="d-flex align-items-center mb-1 w-100" v-if="editingObs === idx">
                <b-textarea max-rows="10" v-model="observacao.observacao" maxlength="4000" :readonly="!hasRole(roles.RW_OPER_PCI_ADM)"></b-textarea>
                <i class="fas fa-save m-2" v-if="hasRole(roles.RW_OPER_PCI_ADM)" @click="onUpdateObs(observacao)"></i>
                <i class="fas fa-times m-2" v-if="hasRole(roles.RW_OPER_PCI_ADM)" @click="editingObs = -1"></i>
              </div>
            </div>
            <div class="d-flex align-items-center mb-1 w-100" v-if="editingObs === null">
              <b-textarea rows="3" max-rows="10" v-model="newObservation" :maxlength="4000" v-if="statusEditable || hasRole(roles.RW_OPER_PCI_ADM)"></b-textarea>
              <i class="fas fa-plus m-2" v-if="hasRole(roles.RW_OPER_PCI_ADM)" @click="onAddObs"></i>
            </div>

            <!--
            <div id="buttonSaveObs" class="w-100 mt-1">
              <b-button variant="third" v-if="statusEditable || hasRole(roles.RW_OPER_PCI_ADM)" @click="onUpdateObs">{{ 'Salvar Observação' }}</b-button>
            </div>
            -->

            <div id="buttonFinalize" v-if="!block.block" class="mx-auto mt-3">
              <b-button v-if="statusPending && hasRole(roles.RW_OPER_PCI_AT_REGIONAL)"
                        variant="third"
                        :disabled="editing || !scrollAllItems"
                        @click="onFinalize">
                <i class="fas fa-check mr-1"></i>{{$lang.PCI.AT.ButtonFinish}}
              </b-button>
              <b-button v-if="(planRevising && hasRole(roles.RW_OPER_PCI_AT_PLAN)) || (budgetRevising && hasRole(roles.RW_OPER_PCI_AT_BUDGET))"
                        variant="third"
                        :disabled="editing"
                        @click="onRevisionFinalize">
                <i class="fas fa-check mr-1"></i>{{$lang.PCI.AT.ButtonFinish}}
              </b-button>
              <b-button v-if="(planRevising && hasRole(roles.RW_OPER_PCI_AT_PLAN)) || (budgetRevising && hasRole(roles.RW_OPER_PCI_AT_BUDGET))"
                        variant="warning"
                        :disabled="editing"
                        @click="onRevisionAbort">
                <i class="fas fa-ban mr-1"></i>{{$lang.PCI.AT.ButtonAbort}}
              </b-button>
            </div>
            <b-tooltip :disabled.sync="scrollAllItems" v-if="!block.block" target="buttonFinalize">{{$lang.PCI.AT.TooltipScrollAllItems}}</b-tooltip>

            <b-card :header="$lang.PCI.AT.LabelRegion"
                    header-tag="strong"
                    v-if="regionApprovable"
                    border-variant="third"
                    class="text-center mx-auto mt-3">
              <b-button @click="onRegionApprove()" :disabled="editing" variant="third">
                <i class="far fa-check-circle mr-1"></i>{{$lang.PCI.AT.ButtonApprove}}
              </b-button>
            </b-card>
            <b-card :header="getLabelPlanApprove"
                    header-tag="strong"
                    v-if="planApprovable && !planRevising"
                    border-variant="third"
                    class="text-center mx-auto mt-3">
              <b-button @click="onPlanningApprove(true)" :disabled="editing" variant="third">
                <i class="far fa-check-circle mr-1"></i>{{$lang.PCI.AT.ButtonApprove}}
              </b-button>
              <b-button @click="onPlanningApprove(false)" :disabled="editing" variant="danger" class="ml-3">
                <i class="fas fa-ban mr-1"></i>{{$lang.PCI.AT.ButtonReject}}
              </b-button>
            </b-card>
            <b-card :header="$lang.PCI.AT.LabelBudget"
                    header-tag="strong"
                    v-if="budgetApprovable && !budgetRevising"
                    border-variant="third"
                    class="text-center mx-auto mt-3">
              <b-button @click="onBudgetApprove(true)" :disabled="editing" variant="third">
                <i class="far fa-check-circle mr-1"></i>{{$lang.PCI.AT.ButtonApprove}}
              </b-button>
              <b-button @click="onBudgetApprove(false)" :disabled="editing" variant="danger" class="ml-3">
                <i class="fas fa-ban mr-1"></i>{{$lang.PCI.AT.ButtonReject}}
              </b-button>
            </b-card>
          </div>
        </div>
        <div v-show="viewLog" class="col-12">
          <SimpleTableList
                  :showTipFooter="false"
                  th_class="text-left"
                  :objList="logTec"
          >
          </SimpleTableList>
        </div>
        <div v-show="viewLogRes" class="col-12">
          <Tables ref="tableGrid" class="col-mdEW-12 tabela"
                  :columns="['FUNÇÃO',
                    'NOME',
                    'ATIVIDADE',
                    'DATA']"
                  :showSearch="false"
                  :showPrint="false"
                  :showDownload="false"
                  :showFullscreen="false"
                  :showPaging="false"
                  :showHeader="false"
                  :showTipFooter="false">
            <tr v-for="(obj, idx) in logTecRes" v-bind:key="idx">
              <TableColumn :IsText="true" classCss="text-left" :value="obj.funcao" />
              <TableColumn :IsText="true" classCss="text-left" :value="obj.nome" />
              <TableColumn :IsText="true" classCss="text-left" :value="obj.atividade" />
              <TableColumn :IsText="true" classCss="text-left" :value="obj.data" />
            </tr>
          </Tables>
        </div>
      </div>
      <b-button v-b-tooltip.hover
                :title="$lang.PCI.AT.TooltipButtonAdditive"
                v-if="!additive && at && (at.statusAprovacao === statusApprove.AG_APROV_ORCAMENTO || at.statusAprovacao === statusApprove.EM_REV_ORCAMENTO) && hasRole(roles.RW_OPER_PCI_AT_BUDGET)"
                class="floatButton"
                @click="onAddAdditive"
                variant="secondary">
        <div class="d-flex">
          <span class="fas fa-plus" style="width: 1.2rem; height: 1.2rem; font-size: 1.2rem;"></span>
        </div>
      </b-button>
    </b-modal>

    <b-modal id="quotesModal"
             ref="quotesModal"
             ok-only
             :ok-title="$lang.Common.Select"
             @ok="onSelectQuoteToImport"
             size="lg">
      <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{$lang.PCI.AT.TitleModalQuote}}
          </span>
          <button class="close" @click="$refs.quotesModal.hide()">x</button>
        </div>
      </template>
      <div style="max-height: calc(100vh - 235px);">
        <ag-grid-vue class="ag-theme-alpine"
                      :getLocaleText="localeTextFunc"
                      :defaultColDef="defaultColumnDef"
                      :gridOptions="gridOptionsQuotes"
                      :suppressHorizontalScroll="true"
                      :columnTypes="columnTypes"
                      :columnDefs="columnDefsQuotes"
                      :rowData="objListQuotesToImport"
                      rowSelection="single"
                      :getRowId="params => params.data.id"
                      :suppressContextMenu="true"
                      :groupHeaderHeight="45"
                      :headerHeight="45"
                      :rowHeight="30"
                      domLayout="autoHeight"
          >
          </ag-grid-vue>
      </div>
    </b-modal>

    <b-modal id="desmembraModal"
             ref="desmembraModal"
             :ok-title="$lang.PCI.AT.ButtonDesmembrar"
             :cancel-title="$lang.Common.No"
             :ok-disabled="!desmembrarValido"
             @ok="onDesmembrar"
             size="md">
      <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{$lang.PCI.AT.TitleDesmembrar}}
          </span>
          <button class="close" @click="$refs.desmembraModal.hide()">x</button>
        </div>
      </template>
      <div>
        <p class="mb-2">{{$lang.PCI.AT.LabelSitesDesmembrar}}</p>
        <b-form-checkbox-group v-model="sitesDesmembrar" stacked>
          <b-form-checkbox v-for="site in sitesDaAt" :key="site.obraID" :value="site.obraID">
            {{ site.obra ? `${site.obra.idSite} (${site.obra.referencia})` : site.obraID }}
          </b-form-checkbox>
        </b-form-checkbox-group>
        <b-alert class="mt-3 mb-0" variant="warning" :show="sitesDesmembrar.length >= sitesDaAt.length">
          {{$lang.PCI.AT.WarningDesmembrarTodos}}
        </b-alert>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TecAnalisys from './tecanalysis.js'
export default TecAnalisys
</script>

<style scoped>
div#change-lpu {
  width: -moz-available;
  width: -webkit-fill-available;
  width: stretch;
}

i {
  font-size: 1rem;
  cursor: pointer;
}

strong {
  white-space: nowrap;
}

button.floatButton {
  position: sticky;
  display: block;
  bottom: 2rem;
  padding: 0.8rem;
  border-radius: 50%;
  box-shadow: 1px 1px 3px 0 black;
  margin-left: auto;
  margin-right: 1rem;
  margin-bottom: 1rem;
  margin-top: -1.5rem;
}

* >>> div.popover {
  max-width: 40vw;
  max-height: 40vh;
}

* >>> div.popover-body {
  max-width: 40vw;
  max-height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
}

* >>> div.popover pre {
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
  font-size: var(--ag-font-size);
  font-family: "Verdana","Segoe UI","Open Sans",Helvetica,Arial,sans-serif;
  max-height:20rem;
}

* >>> .ag-header-cell {
  background-color: #008144;
}
* >>> .ag-cell.ag-cell-auto-height {
    min-height: 100%;
}
* >>> #tecAnalysisModal .modal-content {
  min-height: calc(100vh - 100px);
}
* >>> .modal-header {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
* >>> .modal-body {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  /* scroll-snap-type: y proximity; */
  overflow-y: scroll;
}
* >>> .modal-footer {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
* >>> .modal-content {
  border-radius: 25px;
}
* >>> .changed {
  background-color: #f16e57
}
* >>> .changed-plan {
  background-color: yellow;
}
* >>> .ag-row-no-animation .ag-row.group-row {
  background-color: #9f9f9f;
}
* >>> .ag-row-no-animation .ag-row.subgroup-row {
  background-color: silver;
}

* >>> .ag-row-no-animation .ag-row.revision-row {
  background-color: #88c7a7;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/tecanalysis/tecanalysis.vue